import { RootState } from "@/app/appStore";

export const selectProfileSidebar = (state: RootState) => state.profileSidebar;
export const selectIsProfileSidebarOpen = (state: RootState) => state.profileSidebar.isProfileSidebarOpen; 